import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import {
  vsObjectName as ContractInstanceName,
  defaultSort,
} from "./contractInstance";

export const vsObjectName = "contractNumber";

const url = "/api/contract/contractNumber";

contractNumberConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function contractNumberConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  configureColumnDefinitionSet(columnDefinitionSetServiceProvider);
  configureGrid(recordGridViewServiceProvider);
}
function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    (serverUtility: ServerUtility): GridConfiguration => {
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: `${defaultSort},ContractNumberTypeName,Number`,
        namePlural: "Contract Numbers",
        nameSingular: "Contract Number",
        gridDataSource: new RecordDataSource(serverUtility, url),
      };
    },
  ]);
}
function configureColumnDefinitionSet(
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    ColumnDefinitionServiceName,
    (
      columnDefinitionSetService: ColumnDefinitionSetService,
      columnDefinitionService: ColumnDefinitionService
    ): ColDef[] => {
      const contractInstanceColumns =
        columnDefinitionSetService.getColumnDefinitionSet(
          ContractInstanceName
        ) ?? [];

      return [
        columnDefinitionService.getIdColDef(),
        columnDefinitionService.getStringColDef({
          field: "ContractNumberTypeName",
          header: "Number Type",
        }),
        columnDefinitionService.getStringColDef({
          field: "Number",
        }),
        ...contractInstanceColumns,
      ];
    },
  ]);
}
